import * as types from './actionType.js';
import asyncActionCreator from '../../../utils/asyncActionCreator';
import API from '../../../API/api'


//获得filter
const getFilterListAsyncRequest = (data) => ({
    type: types.GET_FILTER_LIST_REQUEST,
    payload: data
});

const getFilterListAsyncSuccess = (data) => ({
    type: types.GET_FILTER_LIST_SUCCESS,
    payload: data
});

const getFilterListAsyncFailure = (error) => ({
    type: types.GET_FILTER_LIST_FAILURE,
    payload: error
});
export const getFilterList = (data,callback) => asyncActionCreator(
    API.FRAMEEWORK_FILTER,
    getFilterListAsyncRequest,
    getFilterListAsyncSuccess,
    getFilterListAsyncFailure,
    'POST',
    data,
    callback
);


//获得知识点关联时的考点树
const getTreeDataAsyncRequest = (data) => ({
    type: types.GET_TREEDATE_LIST_REQUEST,
    payload: data
});

const getTreeDataAsyncSuccess = (data) => ({
    type: types.GET_TREEDATE_KNOW_LIST_SUCCESS,
    payload: data
});

const getTreeDataAsyncFailure = (error) => ({
    type: types.GET_TREEDATE_LIST_FAILURE,
    payload: error
});
export const getTreeData = (data,callback) => asyncActionCreator(
    API.FRAMEEWORK_KNOWLEDGE_ISSUE_TREE,
    getTreeDataAsyncRequest,
    getTreeDataAsyncSuccess,
    getTreeDataAsyncFailure,
    'POST',
    data,
    callback
);
//获得知识点关联时的知识点树
const getTreeDataKnowAsyncRequest = (data) => ({
    type: types.GET_TREEDATE_KNOW_LIST_REQUEST,
    payload: data
});

const getTreeDataKnowAsyncSuccess = (data) => ({
    type: types.GET_TREEDATE_KNOW_LIST_SUCCESS,
    payload: data
});

const getTreeDataKnowAsyncFailure = (error) => ({
    type: types.GET_TREEDATE_KNOW_LIST_FAILURE,
    payload: error
});
export const getTreeDataKnow = (data,callback) => asyncActionCreator(
    API.FRAMEEWORK_KNOWLEDGE_KNOW_TREE,
    getTreeDataKnowAsyncRequest,
    getTreeDataKnowAsyncSuccess,
    getTreeDataKnowAsyncFailure,
    'POST',
    data,
    callback
);


//获得版本列表
const getEditionListAsyncRequest = (data) => ({
    type: types.GET_EDITION_LIST_REQUEST,
    payload: data
});

const getEditionListAsyncSuccess = (data) => ({
    type: types.GET_EDITION_LIST_SUCCESS,
    payload: data
});

const getEditionListAsyncFailure = (error) => ({
    type: types.GET_EDITION_LIST_FAILURE,
    payload: error
});
export const getEditionList = (data,callback) => asyncActionCreator(
    API.FRAMEEWORK_EDITION_LIST,
    getEditionListAsyncRequest,
    getEditionListAsyncSuccess,
    getEditionListAsyncFailure,
    'POST',
    data,
    callback
);

//获得课本列表
const getBookListAsyncRequest = (data) => ({
    type: types.GET_BOOK_LIST_REQUEST,
    payload: data
});

const getBookListAsyncSuccess = (data) => ({
    type: types.GET_BOOK_LIST_SUCCESS,
    payload: data
});

const getBookListAsyncFailure = (error) => ({
    type: types.GET_BOOK_LIST_FAILURE,
    payload: error
});
export const getBookList = (data,callback) => asyncActionCreator(
    API.FRAMEEWORK_BOOK_LIST,
    getBookListAsyncRequest,
    getBookListAsyncSuccess,
    getBookListAsyncFailure,
    'POST',
    data,
    callback
);

//获得教辅列表
const getAssistListAsyncRequest = (data) => ({
    type: types.GET_ASSIST_LIST_REQUEST,
    payload: data
});

const getAssistListAsyncSuccess = (data) => ({
    type: types.GET_ASSIST_LIST_SUCCESS,
    payload: data
});

const getAssistListAsyncFailure = (error) => ({
    type: types.GET_ASSIST_LIST_FAILURE,
    payload: error
});
export const getAssistList = (data,callback) => asyncActionCreator(
    API.FRAMEEWORK_ASSIST_LIST,
    getAssistListAsyncRequest,
    getAssistListAsyncSuccess,
    getAssistListAsyncFailure,
    'POST',
    data,
    callback
);
export const setPropsEditionCurrent = (data) => ({
    type: types.SET_PROPS_EDITION_CURRENT,
    payload: data
});


export const setPropsBookCurrent = (data) => ({
    type: types.SET_PROPS_BOOK_CURRENT,
    payload: data
});
export const setPropsAssistCurrent = (data,assist) => ({
	    type: types.SET_PROPS_ASSIST_CURRENT,
	    payload: {data,assist},
});
	

export const setPropsEditionList = (data) => ({
    type: types.SET_PROPS_EDITION_LIST,
    payload: data
});
export const setPropsBookList = (data) => ({
    type: types.SET_PROPS_BOOK_LIST,
    payload: data
});
export const setPropsAssistList = (data) => ({
    type: types.SET_PROPS_ASSIST_LIST,
    payload: data
});


export const setHandleEdition = (data) => ({
    type: types.HANDLE_EDITION,
    payload: data
});

export const setHandleAssist = (data) => ({
    type: types.HANDLE_ASSIST,
    payload: data
});

export const setHandleBook = (data) => ({
    type: types.HANDLE_BOOK,
    payload: data
});



// WEBPACK FOOTER //
// ./src/entry_app/knowledge_assist/assist/action.js